<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/' }"
          >常用业务手册</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div class="contentBox">
      <div class="leftBox tree_container">
        <el-tree
          class="show-tree"
          ref="eltree"
          :data="treeData"
          :props="defaultProps"
          :render-content="renderContent"
          :highlight-current="true"
          node-key="id"
          :default-expanded-keys="treeExpandData"
          :current-node-key="keyId"
          @node-click="handleNodeClick"
        >
          <!-- highlight-current 高亮显示 不让背景消失  如果想取消选中也可以在某个事件上为false就可以随着点击事件取消高亮 -->
        </el-tree>
      </div>
      <div class="rightBox">
        <div class="tags">
          <div
            style="
              padding: 26px 20px;
              line-height: 100px;
              display: flex;
              justify-content: space-between;
              background: #ffffff;
            "
          >
            <div
              class="tag"
              v-for="(item, index) in tagData"
              :key="index"
              @click="tagFun(item.type)"
              :class="{ tagTrue: item.type === tagNum }"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="listBox">
          <div class="crumbsBox">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item
                v-for="(item, index) in crumbslist"
                :key="index"
                >{{ item }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
          <!-- 法规变迁 -->
          <div v-if="tagNum == '3'">
            <div class="fgbqNum">
              这项分类中有<span style="color: #ff0000">{{ fgbq.size }}</span
              >条法规条款发生过变迁，涉及<span
                style="color: #ff0000"
                v-if="fgbq.list.size > 0"
                >{{ fgbq.text }}{{ fgbq.list.size }}</span
              ><span v-else style="color: #ff0000">0</span
              >个方面内容，以下为相关的法规条款：
            </div>
            <div class="fgbqList">
              <div class="fgbqTypeList" v-for="(item, index) in list">
                <div class="type" v-if="item">
                  <div class="typeNum">变迁条款{{ index + 1 }}</div>
                  <div class="typeIntro">
                    主要变迁内容：<span style="color: #ff0000">{{
                      item.fgbqType
                    }}</span>
                    现行有效法规1条，过时失效法规{{ item.fgbqList.length }}条。
                  </div>
                </div>
                <div class="list">
                  <div class="title">
                    <span>现行有效法规1</span>
                    <span class="time">发文日期：{{ item.publish_time |  formatDate}}</span>
                  </div>
                  <div class="content" v-html="item.content"></div>
                  <div class="more">
                    <span>详见原文</span>
                  </div>
                </div>
                <div class="list" v-for="(item, index) in item.fgbqList">
                  <div class="title titleFalse">
                    <span>过时失效法规{{ index + 1 }}</span>
                    <span class="time">发文日期：{{ item.publish_time |  formatDate}}</span>
                  </div>
                  <div class="content" v-html="item.content"></div>
                  <div class="more">
                    <span>详见原文</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 名词解释 -->
          <div class="mcjsList" v-if="tagNum == '0'">
            <div class="list" v-for="(item, index) in list" :key="index">
              <div class="title">{{ item.title }}</div>
              <div class="content" v-html="item.content"></div>
            </div>
          </div>
          <!-- 法规依据 -->
          <div class="fgyjList" v-if="tagNum == '1'">
            <div class="fgTags">
              <div class="fgTag fgTagTrue">基本法规</div>
              <div class="fgTag">相关国家法规</div>
              <div class="fgTag">相关地方法规</div>
            </div>
            <div class="list" v-for="(item, index) in list">
              <div class="content">
                <span
                  style="
                    padding-right: 10px;
                    font-size: 18px;
                    font-weight: bold;
                    line-height: 24px;
                    letter-spacing: 0em;
                    color: #003fa8;
                  "
                  >{{ index + 1 }}.</span
                >
                <span v-html="item.content"></span>
              </div>
              <div class="source">
                政策来源:
                <span
                  style="
                    font-size: 14px;
                    font-weight: normal;
                    line-height: 32px;
                    letter-spacing: 0em;
                    color: #0000ff;
                  "
                >
                  {{ item.parentList[0].title }}
                </span>
              </div>
              <div class="timeBox">
                <span>效力范围:有效文件</span>
                <span class="time">发文日期:{{ item.publish_time  |  formatDate}}</span>
              </div>
            </div>
          </div>
          <!-- 相关解读 和法规依据共用CSS样式 -->
          <div class="fgyjList" v-if="tagNum == '2'">
            <div class="fgTags">
              <div class="fgTag fgTagTrue">基本法规</div>
              <div class="fgTag">相关国家法规</div>
              <div class="fgTag">相关地方法规</div>
            </div>
            <div class="list" v-for="(item, index) in list">
              <div class="content">
                <span
                  style="
                    padding-right: 10px;
                    font-size: 18px;
                    font-weight: bold;
                    line-height: 24px;
                    letter-spacing: 0em;
                    color: #003fa8;
                  "
                  >{{ index + 1 }}.</span
                >
                <span v-html="item.content"></span>
              </div>
              <div class="source">
                政策来源:
                <span
                  style="
                    font-size: 14px;
                    font-weight: normal;
                    line-height: 32px;
                    letter-spacing: 0em;
                    color: #0000ff;
                  "
                >
                  {{ item.parentList[0].title }}
                </span>
              </div>
              <div class="timeBox">
                <span>效力范围:有效文件</span>
                <span class="time">发文日期:{{ item.publish_time |  formatDate}}</span>
              </div>
            </div>
          </div>
          <!-- 对应案例 -->
          <div class="dyalList" v-if="tagNum == '4'">
            <div class="list" v-for="(item, index) in list">
              <div class="title">
                <span class="sizeColor">{{ index + 1 }}.问:</span>
                {{ item.title }}
              </div>
              <div class="content">
                <span class="sizeColor">答:</span
                ><span v-html="item.content"></span>
              </div>
              <div class="time">发布日期:{{ item.publish_time |  formatDate}}</div>
            </div>
          </div>
          <!-- 相关观点 -->
          <div class="dyalList" v-if="tagNum == 5">
            <div class="list" v-for="(item, index) in list">
              <div class="content">
                <span class="sizeColor">{{ index + 1 }}.</span>{{ item.title }}
              </div>
              <div class="time">发布日期:{{ item.publish_time }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import blueAdd from "../assets/icon/00b-15px_15px.png";
import bluesubtract from "../assets/icon/01b-15px_15px.png";
import add from "../assets/icon/00a-15px_15px.png";
import subtract from "../assets/icon/01a-15px_15px.png";
import blueTrue from "../assets/icon/02b-15px_15px.png";
import blank from "../assets/icon/02a-15px_15px.png";
import { tagTreeCache, dataSearch } from "../api/api";
export default {
  name: "index",
  data() {
    return {
      tagData: [
        {
          name: "名词解释",
          type: "0",
        },
        {
          name: "法规依据",
          type: "1",
        },
        {
          name: "相关解读",
          type: "2",
        },
        {
          name: "法规变迁",
          type: "3",
        },
        {
          name: "对应案例",
          type: "4",
        },
        {
          name: "相关观点",
          type: "5",
        },
      ],
      treeData: [
        // {
        //   id: "1",
        //   name: "schoolDb",
        //   type: "category",
        //   children: [
        //     { id: "1-1", name: "user_t", type: "rain",children:[
        //         {id:'1-1-1',name:'111'},
        //         {id:'1-1-2',name:'222'},
        //         {id:'1-1-3',name:'333'}
        //     ]},
        //     { id: "1-2", name: "class_t", type: "rain" },
        //     { id: "1-3", name: "grade_t", type: "rain" },
        //   ],
        // },
      ],
      defaultProps: {
        //el-tree 树结构默认渲染的字段
        children: "children",
        label: "name",
        isLeaf: "isLeaf", //isLeaf在tree组件里面算是判断有没有子集 相当于可以控制三角显示▶️
      },
      crumbslist: [],
      tagNum: "0",
      list: [],
      treeExpandData: [], //自己定义的用于接收tree树id的数组
      keyId: "",
      page: 1,
      size: 10,
      tagTreeId: "",
      fgbq: {
        size: 0,
        list: [],
        text: "",
      },
    };
  },
  filters: {
    formatDate(time) {
      if (typeof time == "number") {
        try {
          var date = new Date(time);
          var Y = date.getFullYear() + "-";
          var M =
            (date.getMonth() + 1 < 10
              ? "0" + (date.getMonth() + 1)
              : date.getMonth() + 1) + "-";
          var D = date.getDate() + " ";
          return Y + M + D;
        } catch (e) {
          console.log(time);
          return time;
        }
      } else {
        return time.slice(0, 10);
      }
    },
  },
  created() {
    // 获取tree
    this.tree();
  },
  methods: {
    tagFun(v) {
      this.tagNum = v;
      this.dataSearch();
    },
    // 内容数据
    dataSearch() {
      let data = {
        page: this.page,
        size: this.size,
        tagTreeIds: [JSON.stringify(this.tagTreeId)],
        type: this.tagNum,
      };
      dataSearch(data).then((res) => {
        this.fgbq = {
          size: 0,
          list: [],
          text: "",
        };
        console.log(res);
        this.list = res.data.rows;
        if (this.tagNum == 3) {
          this.fgbq.size = this.list.length;
          this.list.forEach((element) => {
            this.fgbq.list.push(element.fgbqType);
          });
          let arr = new Set(this.fgbq.list);
          this.fgbq.list = arr;
          this.fgbq.list.forEach((element) => {
            this.fgbq.text += element + ",";
          });

          console.log(this.fgbq);
        }
      });
    },

    tree() {
      let data = {
        /* 
            常用 6557331 
            税种 6558575 
            规费基金 6561976 
            行业常用6562083 
            企业经营行为6563043 
            税干常用6563911 
            会计常用6564398 
            税收优惠6564533
            进出口 6565603
            */
        rootId: "6557331",
        typeIds: "",
      };
      tagTreeCache(data).then((res) => {
        console.log(res);
        this.treeData = res.data.data.children;
        this.getEquipmentList();
        this.dataSearch();
      });
    },
    crumbsFun(v) {
      if (v.parent != null) {
        this.crumbslist.unshift(v.data.name);
        this.crumbsFun(v.parent);
      } else {
        console.log(this.list);
      }
    },
    // 获取树形结构默认展开节点
    getRoleTreeRootNode(provincialCenterId) {
      this.treeExpandData.push(provincialCenterId);
    },
    //获取tree树列表
    getEquipmentList(params) {
      console.log(this.treeData);
      this.keyId = this.treeData[0].children[0].id; //默认选中节点
      this.$nextTick(() => {
        this.$refs.eltree.setCurrentKey(this.keyId);
      });
      this.tagTreeId = this.keyId;
      this.crumbslist.unshift(
        this.treeData[0].name,
        this.treeData[0].children[0].name
      ); //默认面包屑
      this.provincialCenterId = this.treeData[0].id; //默认展开第一个节点
      this.getRoleTreeRootNode(this.provincialCenterId);
      if (this.treeData[0].children[0].children) {
        //判断选中节点是否存在子节点 如果存在展开当前选中节点
        this.getRoleTreeRootNode(this.keyId);
      }
    },
    handleNodeClick(data, node) {
      console.log(data);
      console.log(node);
      this.crumbslist = [];
      this.crumbsFun(node);
      this.tagTreeId = data.id;
      this.dataSearch();
      // this.tagTreeId = data.id
    },
    renderContent: function (h, { node, data, store }) {
      // console.log(data);
      // console.log(node);
      /**
            这个addElement等于的是一个自身的索引为0的东西
            我也不晓得这是个啥回来console看看吧
            大概率是一个dom结构或者是新增dom的东西
        */
      let addElement = arguments[0];
      // 这里判断这个rain类型，是和上面 children 有关系
      /*
            反正在最后返回了一个dom元素，一个i标签和俩span标签
            i标签添加个类名是放置icon图标，后面空span不知道干嘛的
            最后一个span是吧你要填写的文字传进去，他拿的是自身的索引为1的里面的
            我懂了，这个索引应该就是参数，这里拿到的是第二个参数中的数据
         */
      if (node.level === 1) {
        // debugger

        if (node.expanded == false) {
          return (
            <div
              class="tOne"
              style="width:100%;padding:0 20px 0 0;line-height:36px;font-size:18px;color:#003fa8;font-family: SourceHanSansCN-Bold;"
            >
              {node.label}
              <div style="float:right">
                <img src={blueAdd} style="width:15px;height:15px;" />
              </div>
            </div>
          );
        } else {
          return (
            <div
              class="tOne"
              style="width:100%;padding:0 20px 0 0;line-height:36px;font-size:18px;color:#003fa8;font-family: SourceHanSansCN-Bold;"
            >
              {node.label}
              <div style="float:right">
                <img src={bluesubtract} style="width:15px;height:15px;" />
              </div>
            </div>
          );
        }
      } else if (node.level !== 1 && data.children) {
        if (node.expanded == false) {
          return (
            <div
              class="tOne"
              style="line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;"
            >
              <img src={add} style="width:15px;height:15px;margin-right:6px" />
              {node.label}
            </div>
          );
        } else {
          return (
            <div
              class="tOne"
              style="line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;white-space:wrap"
            >
              <img
                src={subtract}
                style="width:15px;height:15px;margin-right:6px"
              />
              {node.label}
            </div>
          );
        }
      } else {
        if (node.isCurrent) {
          return (
            <div
              class="tOne"
              style="line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;white-space:wrap!important;"
            >
              <img
                src={blueTrue}
                style="width:15px;height:15px;margin-right:6px"
              />
              <span>{node.label}</span>
            </div>
          );
        } else {
          return (
            <div
              class="tOne"
              style="line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;white-space:wrap!important;"
            >
              <img
                src={blank}
                style="width:15px;height:15px;margin-right:6px"
              />
              <span>{node.label}</span>
            </div>
          );
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.crumbs {
  height: 24px;
}
.contentBox {
  margin-bottom: 24px;
}
.leftBox {
  width: 28%;
  height: 800px;
  margin-right: 10px;
  //   background: #ff6700;
  display: inline-block;
  vertical-align: top;
  overflow: auto;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}
.rightBox {
  width: calc(100% - 17px - 28%);
  min-height: 800px;
  //   background: cyan;
  display: inline-block;
  vertical-align: top;
  //   box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}
.icon {
  width: 10px;
  height: 10px;
  background: url("../assets/logo.png");
  background-size: 100% 100%;
}
.el-tree > .el-tree-node {
  display: inline-block;
  min-width: 100%;
}
::v-deep .el-tree-node__content {
  font-size: 18px;
  color: #003fa8;
  line-height: 36px;
  height: 36px;
}
::v-deep .el-tree-node:focus > .el-tree-node__content {
  background: #eef8ff;
}
::v-deep .el-icon-caret-right:before {
  content: "";
}
::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
  padding: 0;
}
.tags {
  width: 100%;
  height: 100px;
  margin-bottom: 10px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}
.tag {
  width: calc((100% - 50px) / 6);
  height: 48px;
  background: #f5f5f5;
  font-size: 18px;
  line-height: 48px;
  color: #3d3d3d;
  text-align: center;
  cursor: pointer;
}
.tagTrue {
  background: #eef8ff;
  color: #003fa8;
  font-weight: bold;
}
.listBox {
  background: #fff;
  background: #f5f5f5;
}
.crumbsBox {
  width: calc(100% - 40px);
  // height: 42px;
  padding: 14px 20px;
  background: #eef8ff;
}
.mcjsList {
  background: #fff;
  width: calc(100% - 40px);
  padding: 0 10px 0 30px;
  .list {
    // height: 110px;
    border-bottom: 1px solid #d8d8d8;
    .title {
      color: #003fa8;
      font-size: 16px;
      font-weight: bold;
      padding: 17px 0 11px;
    }
    .content {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0em;
      color: #3d3d3d;
    }
  }
}
.fgyjList {
  background: #fff;
  width: calc(100% - 40px);
  padding: 0 20px;
  .fgTags {
    padding: 20px 0;
    .fgTag {
      display: inline-block;
      vertical-align: top;
      width: 130px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 18px;
      background: #f5f5f5;
      margin-right: 10px;
      margin-bottom: 10px;
      cursor: pointer;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    }
    .fgTagTrue {
      color: #003fa8;
      font-size: 18px;
      font-weight: bold;
      background: #eef8ff;
    }
  }
  .list {
    padding: 0 10px;
    border-bottom: 1px solid #d8d8d8;
    .content {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0em;
      color: #3d3d3d;
    }
    .source {
      font-size: 14px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0em;
      color: #003fa8;
    }
    .timeBox {
      color: #003fa8;
      font-size: 14px;
      line-height: 32px;
      .time {
        margin-left: 50px;
      }
    }
  }
  .list:last-child {
    border: none;
  }
}
.dyalList {
  width: calc(100% - 40px);
  padding: 0 20px;
  background: #fff;
  .list {
    padding: 10px 10px;
    border-bottom: 1px solid #d8d8d8;
    .title {
      line-height: 36px;
      font-size: 16px;
      // font-weight: bold;
      color: #3d3d3d;
      background: #f5f5f5;
    }
    .content {
      line-height: 32px;
      font-size: 16px;
      // font-weight: bold;
      color: #3d3d3d;
    }
    .time {
      line-height: 32px;
      font-size: 14px;
      // font-weight: bold;
      color: #003fa8;
    }
    .sizeColor {
      color: #003fa8;
    }
  }
  .list:last-child {
    border: none;
  }
}
.fgbqNum {
  background: #fff;
  border-radius: 0px 0px 8px 8px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  font-size: 16px;
  line-height: 58px;
  padding: 0 20px;
  margin-bottom: 10px;
}
.fgbqList {
  .fgbqTypeList {
    background: #fff;
    border-radius: 0px 0px 8px 8px;
    margin-bottom: 10px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    .type {
      width: 100%;
      height: 30px;
      padding: 10px 0;
      .typeNum {
        display: inline-block;
        vertical-align: top;
        width: 120px;
        height: 30px;
        background: #003fa8;
        border-radius: 0px 15px 15px 0px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        font-size: 16px;
        margin-right: 20px;
      }
      .typeIntro {
        display: inline-block;
        vertical-align: top;
        line-height: 30px;
      }
    }
    .list {
      padding: 0 20px 15px;
      .title {
        padding: 0 10px;
        width: calc(100% - 20px);
        height: 36px;
        background: #eef8ff;
        line-height: 36px;
        font-size: 16px;
        color: #003fa8;
        font-weight: 700;
        .time {
          font-size: 14px;
          color: #3d3d3d;
          float: right;
          font-weight: 500;
        }
      }
      .titleFalse {
        color: #ff5555;
        background: #fff0f0;
      }
      .content {
        line-height: 32px;
        font-size: 16px;
        color: #3d3d3d;
        padding-left: 10px;
        margin-top: 7px;
      }
      .more {
        height: 24px;
        font-size: 16px;
        line-height: 24px;
        color: #00f;
        span {
          float: right;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
